import {
  createContext,
  ReactNode,
  useState,
  useEffect,
  useContext,
} from "react";
import {
  cepNoMask,
  cpfCnpjNoMask,
  datetimeToDateSendOrder,
  datetimeToDateUS,
  telephoneNoMask,
} from "../functions/mask";
import { getPlugintypeIdByCode } from "../functions/plugintype";
import {
  calculatePriceFractionalToProduct,
  floatToCents,
} from "../functions/price_functions";
import { useAppConfig } from "../hooks/useAppConfig";
import { usePluginspace } from "../hooks/usePluginspace";
import { ConfigType } from "./AppConfigContext";

import { IntegrationType } from "../pages/NewChoosePayment/NewChoosePayment";
import { useDiscount } from "../hooks/useDiscount";
import { useClearSale } from "./ClearSaleContext";

export type DeliveryAddressType = {
  zipcode: string;
  street: string;
  district: string;
  city: string;
  state: string;
  number: string;
  extra: string;
  reference: string;
  name: string;
  phone: string;
};

export type MeasureType = {
  width: number;
  height: number;
  lenght: number;
  weight: number;
};

export type ProductType = {
  id: number;
  name: string;
  image: string;
  unitPrice: number;
  promotionalPrice: number;
  quantity: number;
  stock: number;
  sku: string;
  variation: Array<any>;
  code: string;
  locationId: number;
  pluginspaceHash: string;
  outStock: boolean;
  measures: MeasureType | null;
  additionals?: AdditionalType[];
  observation?: string;
  fractions?: ItemFractionalType[];
  type?: string;
  typeFractional?: string;
  table?: number;
  orderId?: number;
  withDiscout?: boolean;
  oldDiscountPrice?: number;
};

export type ItemFractionalType = {
  description: string;
  id: number;
  name: string;
  code: string;
  price: number;
  quantity: number;
};

export type AdditionalType = {
  code: string;
  name: string;
  price: number;
  quantity: number;
};

export type OrderType = {
  products: ProductType[];
};

type PersonWithdrawal = {
  name: string;
  cpf: string;
};

export type FrenetDeliveryMethodType = {
  AllowBuyLabel: boolean;
  Carrier: string;
  CarrierCode: string;
  DeliveryTime: string;
  Error: boolean;
  OriginalDeliveryTime: string;
  OriginalShippingPrice: string;
  ResponseTime: string;
  ServiceCode: string;
  ServiceDescription: string;
  ShippingPrice: string;
};

export type OrderAddress = {
  cep: string;
  address: string;
  district: string;
  city: string;
  number: string;
  state?: string;
  complement: string;
  reference: string;
  name?: string;
  telephone: string;
  ibge: string;
  otherPersonToWithdrawal?: null | PersonWithdrawal;
  uf?: string;
  extra?: string;
  frenet?: FrenetDeliveryMethodType;
};

export type CustomerType = {
  id?: number;
  customerWinthor?: number;
  name: string;
  email?: string;
  cpf: string;
  birthdate?: string;
  gender?: string;
  telephone: string;
  cep?: string;
  address?: string;
  number?: string;
  complement?: string;
  extra?: string;
  district?: string;
  city?: string;
  state?: string;
  wppNotification?: boolean;
  acceptTermDate: Date;
  ibge?: string;
  inscEstadual?: string;
  validateRegister?: boolean;
};

export type CardType = {
  name: string;
  number: string;
  month: string;
  year: string;
  installments: string;
  brand: string;
  cvv: string;
};

type OrderContextProviderProps = {
  children: ReactNode;
};

type CustomerAddressOrder = {
  zipcode: string;
  street: string;
  number: string;
  extra: string;
  district: string;
  city: string;
  state: string;
  ibge: string;
};

type CustomerTypeOrder = {
  customerId: number;
  name: string;
  phone: string;
  email: string;
  zipcode: string;
  cpf: string;
  cnpj: string;
  optinWhatsapp: boolean;
  lgpdDataAceiteCarta: string | Date;
  birthDate: string;
  gender: string;
  doc: string;
  idTerms: number;
  customerAddress: Array<CustomerAddressOrder>;
  inscEstadual?: string | null;
};

type VariationToOrderType = {
  grid: string;
  value: string;
};

type KitsToOrderType = {
  id: number;
  value: number;
  quantity: number;
  itemCombo: number;
  productKit: number;
  name: string;
  productKitVariation: number;
  productKitVariationCode: number;
  fatherImg: string;
};

type FractionalsToOrderType = {
  comboId: number;
  id: number;
  name: string;
  code: string;
  price: number;
  quantity: number;
  itemcomboId: number;
};

type AdditionalsToOrderType = {
  comboId: number;
  id: number;
  name: string;
  code: string;
  price: number;
  quantity: number;
  itemcomboId: number;
};

type OptionalToOrderType = {
  type: string;
  id: number;
  code: string;
  productName: string;
  quantity: number;
  price: number;
  notes: string;
  productionSector: number;
};

type ProductToOrder = {
  hash: string;
  id: number;
  productName: string;
  code: string;
  quantity: number;
  discount: number;
  price: number;
  codFilial: string;
  info: string;
  chair: string;
  notes: string;
  productSku: string;
  variation: Array<VariationToOrderType>;
  kits?: Array<KitsToOrderType>;
  fractionals?: Array<FractionalsToOrderType>;
  additionals?: Array<AdditionalsToOrderType>;
  optional?: Array<OptionalToOrderType>;
};

type customer_adress = {
  customer: string;
  address: {
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
    extra: string;
  };
};

export type ProcessPreOrderType = {
  transactionId: string;
  type: string;
  pluginspaceId: number;
  //order: JSON,
};

export type OrderToSendType = {
  orderDate: string;
  totalAmountDiscount: number;
  sellerCpfCnpj: string | null;
  guidCart?: string | null;
  customerId: number;
  pluginspaceId: number;
  pluginconfigId: number;
  plugintypeId: number;
  webappHash: string;
  locationId: number;
  sessionIdGuid: string;
  deliveryFee: number;
  discountGeneral: number;
  totalAmountOrder: number;
  account: string;
  gatewayId: number;
  paymentOffline: boolean;
  changeMoney: number;
  building: string;
  sector: string;
  living: string;
  codePay: string;
  codePlan: number;
  paymentItemData: IntegrationType | null;
  nameGateway: string;
  cpfOrder: string;
  typeModality: string;
  orderAddress: OrderAddress | undefined;
  customer: Array<CustomerTypeOrder>;
  products: Array<ProductToOrder>;
  gatewayCard: {
    encryptedCard: string;
  };
  removeService: boolean;
  pix?: boolean;
  tableNumber?: string;
  cardNumber?: string;
  isCounter?: boolean;
  observation?: string;
  landmarkSynkar?: string;
  landmarkSynkarName?: string;
  subscription: SubscriptionType | null;
  serviceTaxes?: number;
  tablePayment?: string;
  urlNotification?: string;
  cupomDiscount?: string;
  typePayment?: string;
  discountPaymentType?: { type: string; discountValue: string };
  sessionId?: string;
  hotelContext?: any;
};

export type SubscriptionType = {
  endpoint: string;
  expirationTime: Date | null;
  keys: {
    auth: string;
    p256dh: string;
  };
};

export type OrderIntegrationPlanType = {
  codePay: string;
  codePlan: number;
  nameGateway: string;
  paymentItemData: IntegrationType;
  nameBrand?: string;
  typePayment?: any;
};

export type SellerInfo = {
  cpf: string;
  email: string;
  id: number;
  name: string;
  numberPhone: string;
  pluginspaceId: number;
  sellerCode?: any;
  image?: string;
};

export type OrderContextType = {
  order: OrderType | undefined;

  orderFinished: OrderType | undefined;
  pushToOrder: (product: ProductType) => void;
  changeProduct: (product: ProductType, totvsMotorAble?: boolean) => void;
  removeProduct: (product: ProductType, totvsMotorAble?: boolean) => void;
  totalValue: number;
  totalValueWithoutDiscount: number;
  freight: number;
  setFreight: (value: number) => void;
  observation: string;
  setObservation: (value: string) => void;
  discountGeneral: number;
  setDiscountGeneral: (value: number) => void;

  type: string;
  setType: (value: string) => void;
  orderAddress: OrderAddress | undefined;
  setOrderAddress: (value: OrderAddress | any) => void;
  customer: CustomerType | undefined;
  setCustomer: (value: CustomerType | any) => void;
  paymentType: string | undefined;
  setPaymentType: (value: string | any) => void;
  cpfInNote: string | undefined;
  setCpfInNote: (value: string | any) => void;
  isCpfInNote: boolean | undefined;
  setIsCpfInNote: (value: boolean | any) => void;
  card: CardType | undefined;
  setCard: (value: CardType | any) => void;
  cardBrand: string[];
  setCardBrand: (value: string[]) => void;
  clearOrder: () => void;
  gatewayId: number | undefined;
  setGatewayId: (value: number | any) => void;
  locationId: number | undefined;
  setLocationId: (value: number | any) => void;
  sellerCpfCnpj: string | undefined;
  setSellerCpfCnpj: (value: string | any) => void;
  integrationPlan: OrderIntegrationPlanType | undefined;
  setIntegrationPlan: (value: OrderIntegrationPlanType | any) => void;
  installment: number | undefined;
  setInstallment: (value: number) => void;
  installmentValue: number | undefined;
  setInstallmentValue: (value: number) => void;
  getInstallment: () => Promise<number>;
  getInstallmentValue: () => Promise<number>;
  generateDataToSendOrderCard: (
    customerToSend: CustomerType,
    encryptedCard: string,
    uuid: string,
    retirarServico: boolean,
    pix?: boolean,
    offline?: boolean,
    cardNumber?: number
  ) => Promise<OrderToSendType | undefined>;
  receipt: string | undefined;
  setReceipt: (value: string | any) => void;
  orderId: number | undefined;
  setOrderId: (value: number | any) => void;
  orderIdExt: string | undefined;
  setOrderIdExt: (value: string | any) => void;
  getOrder: (pluginspaceHash?: string) => Promise<OrderType>;
  getTotalValue: () => Promise<number>;
  getSellerCpfCnpj: () => Promise<string>;
  getTotalValueWithoutDiscount: () => Promise<number>;
  getFreight: () => Promise<number>;
  getObservation: () => Promise<string>;
  getOrderAddress: () => Promise<OrderAddress>;
  getCustomer: () => Promise<CustomerType>;
  getType: () => Promise<string>;
  getCpfInNote: () => Promise<string>;
  getPaymentType: () => Promise<string>;
  getCard: () => Promise<CardType>;
  getCardBrand: () => Promise<string[]>;
  getOrderFinished: () => Promise<OrderType>;
  getReceipt: () => Promise<string>;
  getOrderIdExt: () => Promise<string>;
  getOrderId: () => Promise<number>;
  getGatewayId: () => Promise<number>;
  getLocationId: () => Promise<number>;
  getDiscountGeneral: () => Promise<number>;

  getIntegrationPlan: () => Promise<OrderIntegrationPlanType>;
  totalValueOrder: (withoutTax?: boolean) => Promise<{
    total: number;
    totalWithoutDiscount: number;
  }>;
  encryptOrderStorage: (value: OrderContextType) => Promise<void>;
  dencryptOrderStorage: (value: string) => Promise<OrderContextType | void>;
  synchronizeContextToStorage: () => Promise<void>;
  changeOrderByGuidCart: (
    value: ProductType[],
    orderContext: any
  ) => Promise<void>;
  changeCustomerAdress: (value: any) => Promise<void>;
  changeCustomerAdressByCartPage: (value: any) => Promise<void>;
  getCustomerAdress: () => Promise<{
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
  }>;
  customerAdress: {
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
    extra: string;
  };

  changeCustomerDocument: (value: any) => Promise<void>;
  getCustomerDocument: () => Promise<string | undefined>;

  setGuidCart: (value: string) => void;
  getGuidCart: () => Promise<string>;
  guidCart: string;

  setChangePayment: (value: number) => void;
  getChangePayment: () => Promise<number>;
  changePayment: number;

  setServiceTaxes: (value: number) => void;
  getServiceTaxes: () => Promise<number>;
  serviceTaxes: number;

  setGuidCartPaymentOrder: (value: boolean) => void;
  getGuidCartPayment: () => Promise<boolean>;
  guidCartPayment: boolean;
  setTotalValueWithoutDiscount: (value: number) => void;
  setTotalValue: (value: number) => void;

  changeProcess: (value: any) => Promise<void>;

  setOrderWithDiscount: (value: ProductType[]) => Promise<void>;

  getOrderWithDiscount: () => Promise<any>;
  pix?: boolean;

  changeAddressDelivery: (value: DeliveryAddressType) => void;
  getAddressDelivery: () => null | DeliveryAddressType;

  //variaveis novas utilizadas no link do Vendedor
  cpfVendor: string;
  getCpfVendorByLink: () => Promise<string>;
  cpfVendorByLink: (value: string) => void;

  shouldUpdadeCart: boolean;
  getshouldUpdadeCart: () => Promise<boolean>;
  setShouldUpdadeCustomerCart: (value: boolean) => void;

  getGuidCartNew: () => Promise<string>;
  setGuidCartNew: (value: string) => void;

  //Usado para deixar o carrinho mais inteligente, para que n fique toda hora que ocorrer uma mudaça do carrinho ficar verificando o estoque novamente
  // mais utilizado para quando remover um produto ou diminuir uma quantidade do produto no carrinho, o inverso sempre ocorrera uma verificaçao de estoque;
  getOrderToVerify: (pluginspaceHash?: string) => Promise<OrderType | null>;
  setOrderToVerify: (order: OrderType) => void;
  orderToVerify: OrderType | undefined;

  setProductsOrder: (products: ProductType[]) => Promise<void>;

  //Informação do vendedor
  setSellerInfoData: (sellerInfo: SellerInfo) => Promise<void>;
  sellerInfo: SellerInfo | null;
  getSellerInfo: () => Promise<SellerInfo | null>;

  //Informação para validar catalogo unico enviado pelo vendedor
  catalogSeller: string;
  setCatalogSellerFunction: (value: string) => void;
  getCatalogSeller: () => Promise<string>;

  getPaymentDiscount: () => Promise<{
    type: string;
    discountValue: string;
  } | null>;
  setPaymentDiscountFunction: (
    data: {
      typeDiscount: string;
      discountValue: string;
    } | null
  ) => void;
  removePaymentDiscountFunction: () => void;
  paymentDiscount: { type: string; discountValue: string } | null;
  originalSellerFreight: number | null;
  setOriginalSellerFreight: (freight: number) => void;
  isSellerCart: boolean;
  setIsSellerCart: (value: boolean) => void;
};

export const OrderContext = createContext({} as OrderContextType);

export function OrderContextProvider(props: OrderContextProviderProps) {
  /**Usado para os descontos e envio */
  const discountContext = useDiscount();
  const { sessionId: clearSaleSessionId, getCurrentSessionId } = useClearSale();

  const [order, setOrder] = useState<OrderType>();
  const [orderToVerify, setOrderToVerifyState] = useState<OrderType>();
  const [orderDiscont, setOrderDiscount] = useState<ProductType[]>([]);
  const [orderFinished, setOrderFinished] = useState<OrderType>();
  const [totalValue, setTotalValue] = useState(0);
  const [totalValueWithoutDiscount, setTotalValueWithoutDiscount] = useState(0);
  const [freight, setFreight] = useState(0);
  const [observation, setObservation] = useState("");
  const [type, setType] = useState("");
  const [orderAddress, setOrderAddress] = useState();
  const [customer, setCustomer] = useState();
  const [paymentType, setPaymentType] = useState();
  const [cpfInNote, setCpfInNote] = useState();
  const [isCpfInNote, setIsCpfInNote] = useState(false);
  const [card, setCard] = useState();
  const [cardBrand, setCardBrand] = useState<string[]>([]);
  const [gatewayId, setGatewayId] = useState();
  const [locationId, setLocationId] = useState();
  const [receipt, setReceipt] = useState();
  const [orderId, setOrderId] = useState();
  const [orderIdExt, setOrderIdExt] = useState();
  const [integrationPlan, setIntegrationPlan] = useState();
  const [sellerCpfCnpj, setSellerCpfCnpj] = useState();
  const [discountGeneral, setDiscountGeneral] = useState(0);
  const { getThisPluginspace } = usePluginspace();
  const { getAppConfig, getPluginconfig } = useAppConfig();
  const [customerAdress, setCustomerAdress] = useState<{
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
    extra: string;
  }>({
    address: "",
    cep: "",
    city: "",
    complement: "",
    district: "",
    name: "",
    number: "",
    reference: "",
    telephone: "",
    state: "",
    ibge: "",
    extra: "",
  });
  const [changePayment, setChangePayment] = useState(0);

  const [guidCart, setGuidCart] = useState<string>("");

  const [guidCartPayment, setGuidCartPayment] = useState<boolean>(false);

  //Teste
  const [processPreOrder, setProcessPreOrder] = useState();

  //Variavel utilizada pelo novo link do vendedor
  const [cpfVendor, setCpfVendor] = useState("");
  // ao fazer a verificação da disponibilidade do estoque dos produtos,
  //atualizar o carrinho no banco de acordo com essa variavel e depois o valor do Customer do Carrinho
  const [shouldUpdadeCart, setShouldUpdateCart] = useState(false);

  const [serviceTaxes, setServiceTaxes] = useState(0);

  const [cupomDiscount, setCupomDiscount] = useState("");

  const [paymentDiscount, setPaymentDiscount] = useState<{
    type: string;
    discountValue: string;
  } | null>(null);

  //Numero do Telefone do vendedor caso o cliente tenha recebido um carrinho.
  const [sellerInfo, setSellerInfo] = useState<SellerInfo | null>(null);

  //Informação para validar catalogo unico enviado pelo vendedor
  const [catalogSeller, setCatalogSeller] = useState<string>("");

  const [installment, setInstallment] = useState<number>();
  const [installmentValue, setInstallmentValue] = useState<number>();

  const [originalSellerFreight, setOriginalSellerFreight] = useState<
    number | null
  >(null);
  const [isSellerCart, setIsSellerCart] = useState(false);

  function setCatalogSellerFunction(value: string) {
    setCatalogSeller(value);
    localStorage.setItem("catalogSeller", value);
  }
  async function getCatalogSeller() {
    if (catalogSeller) {
      return catalogSeller;
    }
    const catalogSellerStorage = localStorage.getItem("catalogSeller");

    if (catalogSellerStorage) {
      setCatalogSeller(catalogSellerStorage);
      return catalogSellerStorage;
    }
    return "";
  }

  async function getDiscountCoupom() {
    const cupomDiscountStorage = localStorage.getItem("cupom");

    if (cupomDiscountStorage) {
      setCupomDiscount(cupomDiscountStorage);
      return cupomDiscountStorage;
    }
    return "";
  }

  function verifyOrderItems(pluginspaceHash: string, orderStorage: OrderType) {
    const newOrder: OrderType = {
      products: orderStorage.products.filter(
        (product: ProductType) => product.pluginspaceHash === pluginspaceHash
      ),
    };
    return newOrder;
  }

  async function synchronizeContextToStorage() {
    const orderStorage: string | null = localStorage.getItem("order");

    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      const cupomDiscount = await getDiscountCoupom();
      const discountByCupom = 0;
      if (orderContext.order) setOrder(orderContext.order);
      if (orderContext.orderFinished)
        setOrderFinished(orderContext.orderFinished);
      if (orderContext.totalValue) setTotalValue(orderContext.totalValue);
      if (orderContext.totalValueWithoutDiscount)
        setTotalValueWithoutDiscount(orderContext.totalValueWithoutDiscount);
      if (orderContext.freight) setFreight(orderContext.freight);
      if (orderContext.type) setType(orderContext.type);
      if (orderContext.orderAddress) setOrderAddress(orderContext.orderAddress);
      if (orderContext.customer) setCustomer(orderContext.customer);
      if (orderContext.paymentType) setPaymentType(orderContext.paymentType);
      if (orderContext.cpfInNote) setCpfInNote(orderContext.cpfInNote);
      if (orderContext.isCpfInNote) setIsCpfInNote(orderContext.isCpfInNote);
      if (orderContext.card) setCard(orderContext.card);
      if (orderContext.gatewayId) setGatewayId(orderContext.gatewayId);
      if (orderContext.locationId) setLocationId(orderContext.locationId);
      if (orderContext.receipt) setReceipt(orderContext.receipt);
      if (orderContext.orderId) setOrderId(orderContext.orderId);
      if (orderContext.orderIdExt) setOrderIdExt(orderContext.orderIdExt);
      if (orderContext.integrationPlan)
        setIntegrationPlan(orderContext.integrationPlan);
      if (orderContext.sellerCpfCnpj)
        setSellerCpfCnpj(orderContext.sellerCpfCnpj);
      if (orderContext.observation) setObservation(orderContext.observation);

      if (orderContext.processPreOrder)
        setProcessPreOrder(orderContext.processPreOrder);
      if (orderContext.changePayment)
        setChangePayment(orderContext.changePayment);

      if (orderContext.shouldUpdadeCart)
        setShouldUpdateCart(orderContext.shouldUpdadeCart);

      if (orderContext.guidCart) setGuidCart(orderContext.guidCart);

      if (orderContext.cpfVendor) setCpfVendor(orderContext.cpfVendor);

      if (orderContext.serviceTaxes) setServiceTaxes(orderContext.serviceTaxes);

      if (orderContext.discountByCupom) {
        saveDiscountByCupom(discountByCupom);
      }

      setCupomDiscount(cupomDiscount);
    }
  }

  async function encryptOrderStorage(orderStorage: OrderContextType) {
    const CryptoJS = require("crypto-js");
    let secretKey = "ninegridCrypoToken";
    if (process.env.REACT_APP_JWT_SALT) {
      secretKey = process.env.REACT_APP_JWT_SALT;
    }
    const orderEncrypted = CryptoJS.AES.encrypt(
      JSON.stringify(orderStorage),
      secretKey
    ).toString();
    localStorage.setItem("order", orderEncrypted);
  }

  async function saveDiscountByCupom(value: any) {
    const CryptoJS = require("crypto-js");
    let secretKey = "ninegridCrypoToken";
    if (process.env.REACT_APP_JWT_SALT) {
      secretKey = process.env.REACT_APP_JWT_SALT;
    }
    const orderEncrypted = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      secretKey
    ).toString();
    localStorage.setItem("discountByCupom", orderEncrypted);
  }

  async function dencryptOrderStorage(orderEncrypted: string) {
    const CryptoJS = require("crypto-js");
    let secretKey = "ninegridCrypoToken";
    if (process.env.REACT_APP_JWT_SALT) {
      secretKey = process.env.REACT_APP_JWT_SALT;
    }
    const bytes = CryptoJS.AES.decrypt(orderEncrypted, secretKey);
    const orderDencrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    orderDbContext(orderDencrypted);
    return orderDencrypted;
  }

  async function orderDbContext(orderStorage: OrderContextType) {
    const jsonData = JSON.parse(JSON.stringify(orderStorage));
  }

  async function getSellerCpfCnpj() {
    if (sellerCpfCnpj) {
      return sellerCpfCnpj;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext && orderContext.sellerCpfCnpj) {
          setSellerCpfCnpj(orderContext.sellerCpfCnpj);
          return orderContext.sellerCpfCnpj;
        }
      }
    }
    return "";
  }

  async function getIntegrationPlan() {
    if (integrationPlan) {
      return integrationPlan;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext && orderContext.integrationPlan) {
          setIntegrationPlan(orderContext.integrationPlan);
          return orderContext.integrationPlan;
        }
      }
    }
    const orderEmpty: OrderType = {
      products: [],
    };
    return orderEmpty;
  }

  async function getOrder(pluginspaceHash?: string) {
    if (order) {
      if (pluginspaceHash) {
        const orderVerified = verifyOrderItems(pluginspaceHash, order);
        return orderVerified;
      }
      return order;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext && orderContext.order) {
          if (pluginspaceHash) {
            const orderVerified = verifyOrderItems(
              pluginspaceHash,
              orderContext.order
            );
            setOrder(orderVerified);
            return orderVerified;
          } else {
            setOrder(orderContext.order);
            return orderContext.order;
          }
        }
      }
    }
    const orderEmpty: OrderType = {
      products: [],
    };
    return orderEmpty;
  }

  async function getOrderFinished() {
    if (orderFinished) {
      return orderFinished;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.orderFinished) {
          setOrderFinished(orderContext.orderFinished);
          return orderContext.orderFinished;
        }
      }
    }
    const orderEmpty: OrderType = {
      products: [],
    };
    return orderEmpty;
  }

  async function getGatewayId() {
    if (gatewayId) {
      return gatewayId;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.gatewayId) {
          setGatewayId(orderContext.gatewayId);
          return orderContext.gatewayId;
        }
      }
    }
    const orderEmpty: OrderType = {
      products: [],
    };
    return orderEmpty;
  }

  async function getDiscountGeneral() {
    if (discountGeneral !== undefined) {
      return discountGeneral;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.discountGeneral) {
          setDiscountGeneral(orderContext.discountGeneral);
          return orderContext.discountGeneral;
        }
      }
    }
  }

  async function getLocationId() {
    if (locationId) {
      return locationId;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.locationId) {
          setLocationId(orderContext.locationId);
          return orderContext.locationId;
        }
      }
    }

    return 0;
  }

  async function getReceipt() {
    if (receipt) {
      return receipt;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.receipt) {
          setReceipt(orderContext.receipt);
          return orderContext.receipt;
        }
      }
    }
    return "";
  }

  async function getOrderIdExt() {
    if (orderIdExt) {
      return orderIdExt;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.orderIdExt) {
          setOrderIdExt(orderContext.orderIdExt);
          return orderContext.orderIdExt;
        }
      }
    }
    return "";
  }

  async function getOrderId() {
    if (orderId) {
      return orderId;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.orderId) {
          setOrderId(orderContext.orderId);
          return orderContext.orderId;
        }
      }
    }
    return 0;
  }

  async function getOrderAddress() {
    if (orderAddress) {
      return orderAddress;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.orderAddress) {
          setOrderAddress(orderContext.orderAddress);
          return orderContext.orderAddress;
        }
      }
    }
    const orderAddressEmpty: OrderAddress = {
      address: "",
      cep: "",
      city: "",
      complement: "",
      district: "",
      name: "",
      number: "",
      reference: "",
      otherPersonToWithdrawal: undefined,
      telephone: "",
      ibge: "",
    };
    return orderAddressEmpty;
  }

  async function getCustomer() {
    if (customer) {
      return customer;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.customer) {
          setCustomer(orderContext.customer);
          return orderContext.customer;
        }
      }
    }
    const customerEmpty: CustomerType = {
      name: "",
      acceptTermDate: new Date(),
      cpf: "",
      telephone: "",
    };
    return customerEmpty;
  }

  async function getType() {
    if (type) {
      return type;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.type) {
          setType(orderContext.type);
          return orderContext.type;
        }
      }
    }
    return "";
  }

  async function getServiceTaxes() {
    if (serviceTaxes) {
      return serviceTaxes;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.serviceTaxes) {
          setServiceTaxes(orderContext.serviceTaxes);
          return orderContext.serviceTaxes;
        }
      }
    }
    return "";
  }

  async function getCard() {
    if (card) {
      return card;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.card) {
          setCard(orderContext.card);
          return orderContext.card;
        }
      }
    }
    const cardEmpty: CardType = {
      brand: "",
      cvv: "",
      installments: "",
      month: "",
      name: "",
      number: "",
      year: "",
    };
    return cardEmpty;
  }

  async function getCardBrand() {
    return cardBrand ?? [];
  }

  async function getCpfInNote() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.cpfInNote) {
        setCpfInNote(orderContext.cpfInNote);
        return orderContext.cpfInNote;
      }
    }
    return cpfInNote;
  }

  async function getPaymentType() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.paymentType) {
        setPaymentType(orderContext.paymentType);
        return orderContext.paymentType;
      }
    }
    return paymentType;
  }

  async function getTotalValue() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.totalValue) {
        setTotalValue(orderContext.totalValue);
        return orderContext.totalValue;
      }
    }
    return totalValue;
  }

  async function getTotalValueWithoutDiscount() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.totalValueWithoutDiscount) {
        setTotalValueWithoutDiscount(orderContext.totalValueWithoutDiscount);
        return orderContext.totalValueWithoutDiscount;
      }
    }
    return totalValueWithoutDiscount;
  }

  async function getFreight() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.freight) {
        setFreight(orderContext.freight);
        return orderContext.freight;
      }
    }
    return freight;
  }

  async function getObservation() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.observation) {
        setObservation(orderContext.observation);
        return orderContext.observation;
      }
    }
    return observation;
  }

  async function getChangePayment() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.changePayment) {
        setChangePayment(orderContext.changePayment);
        return orderContext.changePayment;
      }
    }
    return observation;
  }

  async function setProductsOrder(products: ProductType[]) {
    let newOrder: OrderType = await getOrder();
    newOrder.products = products;
    setOrder(newOrder);
    totalValueOrder();
  }

  async function pushToOrder(product: ProductType) {
    let newOrder: OrderType = await getOrder();
    let productAlreadyInOrder = false;
    let alreadyQuantityAdd = false;
    const newProducts = newOrder.products.filter((product) => !product.orderId);
    newProducts.forEach((prod) => {
      if (
        prod.id === product.id &&
        prod.sku === product.sku &&
        prod.locationId === product.locationId &&
        JSON.stringify(prod.variation) === JSON.stringify(product.variation)
      ) {
        productAlreadyInOrder = true;

        if (
          prod.fractions &&
          prod.fractions.length > 0 &&
          product.fractions &&
          product.fractions.length > 0
        ) {
          prod.fractions.map((fractional) => {
            if (
              !product.fractions?.find(
                (c) =>
                  c.code === fractional.code &&
                  c.quantity === fractional.quantity
              )
            ) {
              productAlreadyInOrder = false;
            }
          });
        }

        if (prod.additionals && product.additionals) {
          prod.additionals.map((additional) => {
            if (
              !product.additionals?.find(
                (c) =>
                  c.code === additional.code &&
                  c.quantity === additional.quantity
              )
            ) {
              productAlreadyInOrder = false;
            }
          });
        }

        //Se um tiver adicional e o outro não, considera-se exibições diferentes no carrinho
        if (
          product.additionals &&
          product.additionals.length > 0 &&
          (!prod.additionals || prod.additionals.length <= 0)
        ) {
          productAlreadyInOrder = false;
        }
        if (
          prod.additionals &&
          prod.additionals.length > 0 &&
          (!product.additionals || product.additionals.length <= 0)
        ) {
          productAlreadyInOrder = false;
        }

        if (
          product.fractions &&
          prod.fractions &&
          product.fractions.length > 0 &&
          prod.fractions.length > 0 &&
          product.fractions.length !== prod.fractions.length
        ) {
          productAlreadyInOrder = false;
        }

        if (prod.observation !== product.observation) {
          productAlreadyInOrder = false;
        }

        if (productAlreadyInOrder) {
          prod.quantity += product.quantity;
          alreadyQuantityAdd = true;
        }
      }
    });
    if (!alreadyQuantityAdd) newProducts.push(product);
    newOrder.products = newProducts.filter((pd) => pd.quantity > 0);

    /* Aqui é a parte para remover o cupom */
    localStorage.removeItem("cupom");
    setCupomDiscount("");

    saveDiscountByCupom(`0`);
    saveDiscountByCupom(`0`);
    setCupomDiscount("");
    localStorage.removeItem("cupom");

    setOrder(newOrder);
    totalValueOrder();
  }

  async function removeProduct(product: ProductType, totvsMotorAble?: boolean) {
    const actualOrder: OrderType = await getOrder();
    const productsWithQt = actualOrder.products.filter((pd) => pd.quantity > 0);
    const newOrder: OrderType = {
      products: productsWithQt.filter((prod) => {
        if (
          !(
            prod.id === product.id &&
            prod.sku === product.sku &&
            prod.locationId === product.locationId &&
            JSON.stringify(prod.variation) ===
              JSON.stringify(product.variation) &&
            prod.observation === product.observation
          )
        ) {
          return true;
        } else if (product.additionals || product.fractions) {
          const codesAdd =
            product.additionals && product.additionals.length > 0
              ? product.additionals.map((add) => add.code)
              : [];
          const codesFract =
            product.fractions && product.fractions.length > 0
              ? product.fractions.map((fract) => fract.code)
              : [];
          let qtdFract = prod.fractions ? prod.fractions.length : 0;
          let qtdAdd = prod.additionals ? prod.additionals.length : 0;
          let qtdEqualAdd = 0;
          let qtdEqualFract = 0;
          prod.additionals?.forEach((add) => {
            if (codesAdd.includes(add.code)) qtdEqualAdd++;
          });
          prod.fractions?.forEach((fract) => {
            if (codesFract.includes(fract.code)) qtdEqualFract++;
          });

          if (codesAdd.length === 0 && codesFract.length === 0) return false;

          if (
            qtdEqualAdd === codesAdd.length &&
            qtdAdd === codesAdd.length &&
            qtdEqualFract === codesFract.length &&
            qtdFract === codesFract.length
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }),
    };
    newOrder.products.forEach((prod) => {
      if (totvsMotorAble) {
        prod.promotionalPrice = prod.unitPrice;
        product.promotionalPrice = product.unitPrice;
      }
    });

    if (totvsMotorAble) {
      setDiscountGeneral(0);

      saveDiscountByCupom(`0`);
      setCupomDiscount("");
      localStorage.removeItem("cupom");
    }
    totalValueOrder();
    setOrder(newOrder);
  }

  async function changeProduct(product: ProductType, totvsMotorAble?: boolean) {
    let newOrder: OrderType = await getOrder();

    const newProducts = newOrder.products.map((prod) => {
      if (prod.id === product.id && prod.sku === product.sku) {
        prod = { ...product };
      }
      if (totvsMotorAble) {
        prod.promotionalPrice = prod.unitPrice;
        product.promotionalPrice = product.unitPrice;
      }
      return prod;
    });
    newOrder.products = newProducts;
    if (totvsMotorAble) {
      setDiscountGeneral(0);

      saveDiscountByCupom(`0`);
      setCupomDiscount("");
      localStorage.removeItem("cupom");
    }
    totalValueOrder();
    setOrder(newOrder);
  }

  async function totalValueOrder(withoutTax?: boolean) {
    let newTotal = 0;
    let newTotalWithoutDiscount = 0;
    let newOrder: OrderType = await getOrder();
    newOrder.products.map((prod) => {
      if (prod.fractions && prod.fractions.length > 0) {
        let priceFractional = calculatePriceFractionalToProduct(prod);
        newTotalWithoutDiscount += prod.quantity * priceFractional;
        newTotal += prod.quantity * priceFractional;
      } else {
        if (
          prod.unitPrice === prod.promotionalPrice ||
          prod.promotionalPrice === 0
        ) {
          newTotal += prod.quantity * prod.unitPrice;
        } else {
          newTotal += prod.quantity * prod.promotionalPrice;
        }
        newTotalWithoutDiscount += prod.quantity * prod.unitPrice;
      }
      if (prod.additionals) {
        prod.additionals.map((additional) => {
          newTotalWithoutDiscount +=
            prod.quantity * (additional.quantity * additional.price);
          newTotal += prod.quantity * (additional.quantity * additional.price);
        });
      }
      return prod;
    });
    const discountGeneralStorage = await getDiscountGeneral();
    if (discountGeneralStorage) {
      newTotal -= discountGeneralStorage;
    }

    const discountByCupomStorage = 0;
    if (discountByCupomStorage) {
      newTotal -= discountByCupomStorage;
    }

    const serviceTaxesStorage = await getServiceTaxes();
    if (serviceTaxesStorage && !withoutTax) {
      newTotal += serviceTaxesStorage;
      newTotalWithoutDiscount += serviceTaxesStorage;
    }

    setTotalValueWithoutDiscount(newTotalWithoutDiscount);
    setTotalValue(newTotal);
    return {
      totalWithoutDiscount: newTotalWithoutDiscount,
      total: newTotal,
    };
  }

  async function changeOrderByGuidCart(
    products: ProductType[],
    orderContext: any
  ) {
    try {
      let newOrder: OrderType = await getOrder();
      newOrder.products = products;
      setOrder(newOrder);
      await encryptOrderStorage(orderContext);
      await totalValueOrder();
    } catch (error) {
      console.log(error);
    }
  }

  function clearOrder() {
    const orderLocal = localStorage.getItem("order");
    localStorage.setItem("order", "");
    localStorage.setItem("guidCart", "");
    localStorage.setItem("orderdiscount", "");
    localStorage.setItem("orderToVerify", "");
    localStorage.setItem("locations", "");
    localStorage.setItem("storeAddress", "");
    localStorage.setItem("shouldChangeAddressFashion", "");
    setDiscountGeneral(0);

    saveDiscountByCupom(`0`);
    setCupomDiscount("");
    localStorage.removeItem("cupom");
    setReceipt(undefined);
    setChangePayment(0);
    setPaymentType(undefined);
    setIntegrationPlan(undefined);
    if (order) {
      setOrderFinished(order);
      if (orderLocal) localStorage.setItem("orderFinalized", orderLocal);
    }
    setCustomer(undefined);
    setSellerCpfCnpj(undefined);
    setOrder({
      products: [],
    });
  }

  async function generateDataToSendOrderCard(
    customerToSend: CustomerType,
    encryptedCard: string,
    uuid: string,
    retirarServico: boolean,
    pix?: boolean,
    offline?: boolean,
    cardNumber?: number
  ) {
    const pluginspaceData = await getThisPluginspace();
    const orderStorage = await getOrder();
    const totalValueStorage = await getTotalValue();
    const gatewayIdStorage = await getGatewayId();
    const typeStorage = await getType();
    const orderAddressStorage = await getOrderAddress();
    const sellerCpfCnpjStorage = await getSellerCpfCnpj();
    const discountGeneralStorage = await getDiscountGeneral();
    const observationStorage = await getObservation();
    const serviceTaxesStorage = await getServiceTaxes();
    const cupomDiscount = discountContext.data.couponCode;
    const discountByCupom = discountContext.data.couponValue;
    //Variavel utilizada para enviar somente para o food
    const pluginsConfig = await getPluginconfig(true);

    let discountPaymentType = null;

    if (
      discountContext.data.paymentDiscountCode &&
      discountContext.data.paymentDiscountTypeValue
    ) {
      discountPaymentType = {
        type: discountContext.data.paymentDiscountCode,
        discountValue: discountContext.data.paymentDiscountTypeValue.toString(),
      };
    }

    if (
      pluginspaceData &&
      customerToSend != undefined &&
      orderStorage &&
      totalValueStorage
    ) {
      const config: ConfigType | void = await getAppConfig();
      const integrationPlanStorage = await getIntegrationPlan();
      const changePaymentStorage = await getChangePayment();
      let totalAmountDiscount = 0;

      let subscription = null;
      const subscriptionStorage = localStorage.getItem(
        window.btoa("subscription_notification")
      );
      if (
        subscriptionStorage &&
        window.atob(subscriptionStorage) &&
        JSON.parse(window.atob(subscriptionStorage))
      ) {
        subscription = JSON.parse(window.atob(subscriptionStorage));
      }

      const table = localStorage.getItem("table_number");

      const products = orderStorage.products.map((product: ProductType) => {
        const variationProduct = Object.entries(product.variation).map(
          (grid) => {
            return {
              grid: grid[0],
              value: grid[1],
            };
          }
        );
        let additionals: AdditionalsToOrderType[] = [];
        if (product.additionals) {
          product.additionals.map((additional) => {
            additionals.push({
              code: additional.code,
              name: additional.name,
              quantity: additional.quantity,
              price: additional.price,
              comboId: 0,
              id: 0,
              itemcomboId: 0,
            });
          });
        }
        const discount =
          product.unitPrice === product.promotionalPrice ||
          product.promotionalPrice === 0
            ? 0
            : floatToCents(product.unitPrice) -
              floatToCents(product.promotionalPrice);
        totalAmountDiscount += discount * product.quantity;
        return {
          hash: window.btoa(product.code),
          id: product.id,
          productName: product.name,
          code: product.code,
          quantity: product.quantity,
          discount: discount,
          price:
            product.unitPrice === product.promotionalPrice ||
            product.promotionalPrice === 0
              ? floatToCents(product.unitPrice)
              : floatToCents(product.promotionalPrice),
          unitPrice: floatToCents(product.unitPrice),
          codFilial: pluginspaceData.id,
          info: "",
          chair: "",
          notes: "",
          productSku: product.sku,
          variation: variationProduct,
          additionals: product.additionals ? additionals : undefined,
          fractions: product.fractions,
          type: product.type,
          typeFractions: product.typeFractional,
          observation: product.observation,
          orderId: product.orderId,
          image: product.image,
          measures: product.measures ? product.measures : null,
        };
      });
      const orderDate = new Date().toLocaleString("sv");
      const typeId = getPlugintypeIdByCode(pluginspaceData.type);
      if (
        orderAddressStorage.otherPersonToWithdrawal &&
        orderAddressStorage.otherPersonToWithdrawal.cpf
      ) {
        orderAddressStorage.otherPersonToWithdrawal.cpf = cpfCnpjNoMask(
          orderAddressStorage.otherPersonToWithdrawal.cpf
        );
      }

      const dataGateway: OrderToSendType = {
        orderDate: orderDate,
        totalAmountDiscount:
          totalAmountDiscount + floatToCents(discountGeneralStorage),
        sellerCpfCnpj: sellerCpfCnpjStorage ? sellerCpfCnpjStorage : null,
        guidCart: guidCart ? guidCart : null,
        customerId: customerToSend.customerWinthor
          ? customerToSend.customerWinthor
          : 0,
        pluginspaceId: pluginspaceData.id,
        pluginconfigId:
          config && config.content.pdv.pluginconfigId
            ? config.content.pdv.pluginconfigId
            : 0,
        plugintypeId: typeId ? typeId : 0,
        webappHash: pluginspaceData.hash,
        locationId: locationId ? locationId : 0,
        sessionIdGuid: uuid,
        deliveryFee: floatToCents(freight),
        discountGeneral:
          floatToCents(discountGeneralStorage) +
          floatToCents(discountByCupom) +
          floatToCents(discountContext.data.paymentDiscountValue),
        totalAmountOrder:
          floatToCents(totalValueStorage) +
          floatToCents(freight) -
          (serviceTaxesStorage ? floatToCents(serviceTaxesStorage) : 0) -
          floatToCents(discountByCupom) -
          floatToCents(discountContext.data.paymentDiscountValue),
        account: "",
        gatewayId: gatewayIdStorage ? gatewayIdStorage : 0,
        paymentOffline: offline ? offline : false,
        changeMoney: changePaymentStorage
          ? floatToCents(changePaymentStorage) +
            floatToCents(totalValueStorage) +
            floatToCents(freight)
          : 0,
        building: "0",
        sector: "0",
        living: "0",
        codePay:
          integrationPlanStorage && integrationPlanStorage.codePay
            ? integrationPlanStorage.codePay
            : "0",
        codePlan:
          integrationPlanStorage && integrationPlanStorage.codePlan
            ? integrationPlanStorage.codePlan
            : 0,
        nameGateway:
          integrationPlanStorage && integrationPlanStorage.nameGateway
            ? integrationPlanStorage.nameGateway
            : null,
        paymentItemData:
          integrationPlanStorage && integrationPlanStorage.paymentItemData
            ? {
                ...integrationPlanStorage.paymentItemData,
                ...(integrationPlanStorage.paymentItemData.typePay ===
                  "Credit" ||
                integrationPlanStorage.paymentItemData.typePay === "Others"
                  ? {
                      installment: installment ? installment : 1,
                      installmentValue: installmentValue
                        ? parseFloat(installmentValue.toFixed(2))
                        : 0,
                    }
                  : {}),
              }
            : null,
        cpfOrder: cpfInNote ? cpfCnpjNoMask(cpfInNote) : "",
        typeModality: typeStorage,
        orderAddress: orderAddressStorage,
        customer: [
          {
            customerId: customerToSend.id ? customerToSend.id : 0,
            name: customerToSend.name,
            phone: telephoneNoMask(customerToSend.telephone),
            email: customerToSend.email ? customerToSend.email : "",
            zipcode: customerToSend.cep ? cepNoMask(customerToSend.cep) : "",
            cpf:
              cpfCnpjNoMask(customerToSend.cpf).length > 11
                ? ""
                : cpfCnpjNoMask(customerToSend.cpf),
            cnpj:
              cpfCnpjNoMask(customerToSend.cpf).length > 11
                ? cpfCnpjNoMask(customerToSend.cpf)
                : "",
            optinWhatsapp: customerToSend.wppNotification
              ? customerToSend.wppNotification
              : false,
            lgpdDataAceiteCarta: customerToSend.acceptTermDate
              ? customerToSend.acceptTermDate
              : "",
            birthDate: customerToSend.birthdate
              ? datetimeToDateSendOrder(customerToSend.birthdate)
              : "",
            gender: customerToSend.gender ? customerToSend.gender : "",
            doc: cpfCnpjNoMask(customerToSend.cpf).length > 11 ? "cnpj" : "cpf",
            inscEstadual:
              customerToSend.inscEstadual &&
              customerToSend.inscEstadual !== "" &&
              cpfCnpjNoMask(customerToSend.cpf).length > 11
                ? customerToSend.inscEstadual
                : null,
            idTerms: 0,
            customerAddress: [
              {
                zipcode: customerToSend.cep
                  ? cepNoMask(customerToSend.cep)
                  : "",
                street: customerToSend.address ? customerToSend.address : "",
                number: customerToSend.number ? customerToSend.number : "",
                district: customerToSend.district
                  ? customerToSend.district
                  : "",
                city: customerToSend.city ? customerToSend.city : "",
                state: customerToSend.state ? customerToSend.state : "",
                extra: customerToSend.extra ?? customerToSend.complement ?? "",
                ibge: customerToSend.ibge ? customerToSend.ibge : "",
              },
            ],
          },
        ],
        removeService: retirarServico,
        observation: observationStorage ? observationStorage : null,
        products: products,
        gatewayCard: {
          encryptedCard: encryptedCard,
        },
        subscription,
        tablePayment: table
          ? window.atob(table)
          : cardNumber
          ? cardNumber.toString()
          : "",
        serviceTaxes: serviceTaxesStorage ? serviceTaxesStorage : 0,
        cupomDiscount: cupomDiscount ? cupomDiscount : "",
        //novo campo usado para o pedido da moda
        typePayment:
          integrationPlanStorage && integrationPlanStorage.typePayment
            ? integrationPlanStorage.typePayment
            : null,
      };

      //validacao se o pedido é comanda, pois o valor do tablePayment deve ser o numero da comanda

      if (cardNumber) {
        dataGateway.tablePayment = cardNumber.toString();
      }

      if (pix) {
        dataGateway.pix = true;
      }
      const haveCounter = localStorage.getItem("counter_number");
      if (haveCounter) {
        dataGateway.isCounter = true;
      }

      //Verifica se o pedido é para o food
      // recupera o plugin do totvsChef
      if (pluginspaceData && pluginspaceData.type === "food") {
        const totvsChefPlugin = pluginsConfig.find(
          (plugin) => plugin.plugintemplateId === 48
        );

        if (totvsChefPlugin && totvsChefPlugin.id) {
          dataGateway.pluginconfigId = totvsChefPlugin.id;
        }
      }

      /*Fazer a validação do pedido para o tipo de plugin que a loja possui. */
      if (pluginspaceData && pluginspaceData.type !== "food") {
        const pluginConfig = pluginsConfig.find(
          (plugin) =>
            plugin.plugintemplateId === 15 ||
            plugin.plugintemplateId === 23 ||
            plugin.plugintemplateId === 45
        );

        if (pluginConfig && pluginConfig.id) {
          dataGateway.pluginconfigId = pluginConfig.id;
        }
      }

      // campo utilizado para saber se tem o desconto por meio de pagamento
      if (discountPaymentType) {
        dataGateway.discountPaymentType = discountPaymentType;
      }

      // Adiciona sessionId do ClearSale se disponível
      try {
        const currentSessionId = await getCurrentSessionId();
        if (currentSessionId && currentSessionId.length > 0) {
          dataGateway.sessionId = currentSessionId;
          console.log(
            "[OrderFinalize] SessionId do ClearSale adicionado ao pedido:",
            currentSessionId.substring(0, 10) + "..."
          );
        } else {
          console.log(
            "[OrderFinalize] ClearSale sessionId não disponível - pedido será enviado sem sessionId"
          );
        }
      } catch (error) {
        console.warn(
          "[OrderFinalize] Erro ao obter sessionId do ClearSale:",
          error
        );
      }

      return dataGateway;
    }
  }

  function changeAddressDelivery(address: DeliveryAddressType) {
    if (address && JSON.stringify(address)) {
      localStorage.setItem(
        "delivery_address",
        window.btoa(JSON.stringify(address))
      );
    }
    return null;
  }

  function getAddressDelivery() {
    const addressLocal = localStorage.getItem("delivery_address");
    if (addressLocal) {
      const addressString = window.atob(addressLocal);
      if (addressString) {
        const address: DeliveryAddressType = JSON.parse(addressString);
        return address ? address : null;
      }
    }
    return null;
  }

  //Função que troca o endereço do cliente em uma variavel e salva no localStorage
  async function changeCustomerAdress(address: {
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
    extra: string;
  }) {
    const ls = localStorage.getItem("customer_adress");

    if (ls) {
      const localStorageData: customer_adress = JSON.parse(ls);

      let newAddress = { ...localStorageData.address };

      // Validando e mantendo os valores anteriores se necessário
      newAddress.address = address.address;
      newAddress.cep = address.cep;
      newAddress.city = address.city;
      newAddress.complement = address.complement;
      newAddress.district = address.district;
      newAddress.name = address.name;
      newAddress.number = address.number;
      newAddress.reference = address.reference;
      newAddress.telephone = address.telephone;
      newAddress.state = address.state;
      newAddress.ibge = address.ibge;
      newAddress.extra = address.extra;
      localStorageData.address = newAddress;
      setCustomerAdress(localStorageData.address);
      localStorage.setItem("customer_adress", JSON.stringify(localStorageData));
    } else {
      const localStorageData: customer_adress = {
        customer: "",
        address: address,
      };

      setCustomerAdress(address);
      localStorage.setItem("customer_adress", JSON.stringify(localStorageData));
    }
  }

  async function changeCustomerAdressByCartPage(address: {
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
    extra: string;
  }) {
    const ls = localStorage.getItem("customer_adress");

    if (ls) {
      const localStorageData: customer_adress = JSON.parse(ls);

      let newAddress = { ...localStorageData.address };

      if (newAddress.cep !== address.cep) {
        // Validando e mantendo os valores anteriores se necessário
        newAddress.address = address.address;
        newAddress.cep = address.cep;
        newAddress.city = address.city;
        newAddress.complement = "";
        newAddress.district = address.district;
        newAddress.name = "";
        newAddress.number = "";
        newAddress.reference = "";
        newAddress.telephone = "";
        newAddress.state = address.state;
        newAddress.ibge = address.ibge;
        newAddress.extra = "";
      }

      localStorageData.address = newAddress;
      setCustomerAdress(localStorageData.address);
      localStorage.setItem("customer_adress", JSON.stringify(localStorageData));
    } else {
      const localStorageData: customer_adress = {
        customer: "",
        address: address,
      };

      setCustomerAdress(address);
      localStorage.setItem("customer_adress", JSON.stringify(localStorageData));
    }
  }

  async function changeCustomerDocument(document: string) {
    const ls = localStorage.getItem("customer_adress");

    if (ls) {
      const localStorageData: customer_adress = JSON.parse(ls);
      localStorageData.customer = document;
      localStorage.setItem("customer_adress", JSON.stringify(localStorageData));
    } else {
      const localStorageData: customer_adress = {
        customer: document,
        address: {
          address: "",
          cep: "",
          city: "",
          complement: "",
          district: "",
          name: "",
          number: "",
          reference: "",
          telephone: "",
          state: "",
          ibge: "",
          extra: "",
        },
      };
      localStorage.setItem("customer_adress", JSON.stringify(localStorageData));
    }
  }

  async function getCustomerAdress() {
    const ls = localStorage.getItem("customer_adress");

    if (ls) {
      const localStorageData: customer_adress = JSON.parse(ls);
      setCustomerAdress(localStorageData.address);
      return localStorageData.address;
    }
    return {
      address: "",
      cep: "",
      city: "",
      complement: "",
      district: "",
      name: "",
      number: "",
      reference: "",
      telephone: "",
      state: "",
      ibge: "",
    };
  }

  async function getCustomerDocument() {
    const ls = localStorage.getItem("customer_adress");

    if (ls) {
      const localStorageData: customer_adress = JSON.parse(ls);
      return localStorageData.customer;
    }
    return undefined;
  }

  async function getGuidCart() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.guidCart) {
        setGuidCart(orderContext.guidCart);
        return orderContext.guidCart;
      }
    }
    return guidCart;
  }

  async function getGuidCartPayment() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext.guidCartPayment) {
        setGuidCartPayment(orderContext.guidCartPayment);
        return orderContext.guidCartPayment;
      }
    }
    return guidCartPayment;
  }

  async function setGuidCartPaymentOrder(orderContext: any) {
    setGuidCartPayment(true);
    await encryptOrderStorage(orderContext);
  }

  async function setOrderWithDiscount(products: ProductType[]) {
    setOrderDiscount(products);
    localStorage.setItem("orderdiscount", JSON.stringify(products));
  }

  async function getOrderWithDiscount() {
    try {
      if (orderDiscont) {
        return {
          products: orderDiscont,
        };
      }

      const productStorage = localStorage.getItem("orderdiscount");

      if (productStorage) {
        const pA = JSON.parse(productStorage);
        return {
          products: pA,
        };
      }

      return {
        products: [],
      };
    } catch (error) {}
  }

  /* function getProcessOld(){
        const processLocalStore = localStorage.getItem('processPreOrder');

        if (processLocalStore) {
            const processlocalStorageData: ProcessPreOrderType = JSON.parse(processLocalStore)
            processlocalStorageData.transactionId = '';
            processlocalStorageData.type = '';
            processlocalStorageData.pluginspaceId = 0;
            //processlocalStorageData.order = JSON.parse(JSON.stringify({}));
            setProcessPreOrder(processlocalStorageData)
            localStorage.setItem('processPreOrder', JSON.stringify(processlocalStorageData))
            return processlocalStorageData;
        } else {
            const processlocalStorageData: ProcessPreOrderType = {
                transactionId: '',
                type: '',
                pluginspaceId: 0,
                //order: JSON.parse(JSON.stringify(getOrder)),
            }
                setProcessPreOrder(processlocalStorageData)
                localStorage.setItem('processPreOrder', JSON.stringify(processlocalStorageData))
                return processlocalStorageData
        }
        } */

  async function getProcess() {
    if (processPreOrder) {
      return processPreOrder;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext.processPreOrder) {
          setCard(orderContext.processPreOrder);
          return orderContext.processPreOrder;
        }
      }
    }
    const processlocalStorageData: ProcessPreOrderType = {
      transactionId: "",
      type: "",
      pluginspaceId: 0,
    };
    return processlocalStorageData;
  }

  async function changeProcess(address: {
    address: string;
    cep: string;
    city: string;
    complement: string;
    district: string;
    name: string;
    number: string;
    reference: string;
    telephone: string;
    state: string;
    ibge: string;
    extra: string;
  }) {
    const ls = localStorage.getItem("process");

    if (ls) {
      const localStorageData: customer_adress = JSON.parse(ls);
      localStorageData.address = address;
      setCustomerAdress(localStorageData.address);
      localStorage.setItem("process", JSON.stringify(localStorageData));
    } else {
      const localStorageData: customer_adress = {
        customer: "",
        address: address,
      };

      setCustomerAdress(address);
      localStorage.setItem("process", JSON.stringify(localStorageData));
    }
  }

  function cpfVendorByLink(cpf: string) {
    setCpfVendor(cpf);
  }

  async function getCpfVendorByLink() {
    if (cpfVendor) return cpfVendor;

    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext && orderContext.cpfVendor) {
        setCpfVendor(orderContext.cpfVendor);

        return orderContext.cpfVendor;
      }
    }
  }

  async function getshouldUpdadeCart() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext) {
        setShouldUpdateCart(orderContext.shouldUpdadeCart);

        return orderContext.shouldUpdadeCart;
      }
    }
  }
  function setShouldUpdadeCustomerCart(value: boolean) {
    setShouldUpdateCart(value);
  }

  function setGuidCartNew(guidCart: string) {
    setGuidCart(guidCart);
    localStorage.setItem("guidCart", guidCart);
  }

  async function getGuidCartNew() {
    if (guidCart) {
      return guidCart;
    }
    const guidLocalStorare = localStorage.getItem("guidCart");
    setGuidCart(guidLocalStorare!);
    return guidLocalStorare!;
  }
  async function getOrderToVerify(pluginspaceHash?: string) {
    const haveOrderToVerify = localStorage.getItem("orderToVerify");

    if (haveOrderToVerify) {
      const orderToVerify: OrderType = JSON.parse(haveOrderToVerify);

      setOrderToVerifyState(orderToVerify);

      return orderToVerify;
    }

    return null;
  }
  function setOrderToVerify(order: OrderType) {
    localStorage.setItem("orderToVerify", JSON.stringify(order));

    setOrderToVerifyState(order);
  }

  async function setSellerInfoData(sellerInfo: SellerInfo) {
    setSellerInfo(sellerInfo);
  }

  async function getSellerInfo() {
    if (sellerInfo) {
      return sellerInfo;
    }
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext && orderContext.sellerInfo) {
        setSellerInfo(orderContext.sellerInfo);

        return orderContext.sellerInfo;
      }
    }
  }

  async function setPaymentDiscountFunction(
    data: {
      typeDiscount: string;
      discountValue: string;
    } | null
  ) {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext) {
        if (data) {
          setPaymentDiscount({
            type: data.typeDiscount,
            discountValue: data.discountValue,
          });
        } else {
          setPaymentDiscount(null);
        }
        orderContext.paymentDiscount = data;

        await encryptOrderStorage(orderContext);

        return orderContext.paymentDiscount;
      }
    }
    await synchronizeContextToStorage();
  }

  async function removePaymentDiscountFunction() {
    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext) {
        orderContext.paymentDiscount = "";
        await encryptOrderStorage(orderContext);
        return orderContext.paymentDiscount;
      }
    }
  }
  async function getPaymentDiscount(): Promise<{
    type: string;
    discountValue: string;
  } | null> {
    if (paymentDiscount) {
      return paymentDiscount;
    }

    const orderStorage: string | null = localStorage.getItem("order");
    if (orderStorage) {
      const orderContext = await dencryptOrderStorage(orderStorage);
      if (orderContext) {
        setPaymentDiscount(orderContext.paymentDiscount);

        return orderContext.paymentDiscount;
      }
    }

    return null;
  }

  async function getInstallment() {
    if (installment) {
      return installment;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext && orderContext.installment) {
          setInstallment(orderContext.installment);
          return orderContext.installment;
        }
      }
    }
    return 1;
  }

  async function getInstallmentValue() {
    if (installmentValue) {
      return installmentValue;
    } else {
      const orderStorage: string | null = localStorage.getItem("order");
      if (orderStorage) {
        const orderContext = await dencryptOrderStorage(orderStorage);
        if (orderContext && orderContext.installmentValue) {
          setInstallmentValue(orderContext.installmentValue);
          return orderContext.installmentValue;
        }
      }
    }
    return 0;
  }

  useEffect(() => {
    if (sellerInfo) {
      synchronizeContextToStorage();
    }
  }, [sellerInfo]);

  return (
    <OrderContext.Provider
      value={{
        order,
        pushToOrder,
        changeProduct,
        totalValue,
        totalValueWithoutDiscount,
        freight,
        setFreight,
        observation,
        setObservation,
        discountGeneral,
        setDiscountGeneral,

        removeProduct,
        type,
        setType,
        orderAddress,
        setOrderAddress,
        customer,
        setCustomer,
        paymentType,
        setPaymentType,
        cpfInNote,
        setCpfInNote,
        isCpfInNote,
        setIsCpfInNote,
        card,
        setCard,
        cardBrand,
        setCardBrand,
        clearOrder,
        gatewayId,
        setGatewayId,
        locationId,
        setLocationId,
        integrationPlan,
        setIntegrationPlan,
        installment,
        setInstallment,
        installmentValue,
        setInstallmentValue,
        generateDataToSendOrderCard,
        receipt,
        setReceipt,
        orderId,
        setOrderId,
        orderIdExt,
        setOrderIdExt,
        orderFinished,
        sellerCpfCnpj,
        setSellerCpfCnpj,
        getSellerCpfCnpj,
        getOrder,
        getTotalValue,
        getTotalValueWithoutDiscount,
        getFreight,
        getOrderAddress,
        getCustomer,
        getType,
        getCard,
        getCardBrand,
        getCpfInNote,
        getPaymentType,
        getOrderFinished,
        getOrderId,
        getOrderIdExt,
        getReceipt,
        getGatewayId,
        getLocationId,
        getIntegrationPlan,
        getDiscountGeneral,

        getObservation,
        totalValueOrder,
        encryptOrderStorage,
        dencryptOrderStorage,
        synchronizeContextToStorage,
        changeOrderByGuidCart,

        changeCustomerAdress,
        changeCustomerAdressByCartPage,
        getCustomerAdress,
        customerAdress,
        changeCustomerDocument,
        getCustomerDocument,

        setGuidCart,
        getGuidCart,

        setTotalValueWithoutDiscount,
        setTotalValue,
        guidCart,

        setGuidCartPaymentOrder,
        getGuidCartPayment,
        guidCartPayment,

        changeProcess,

        setOrderWithDiscount,
        getOrderWithDiscount,

        changeAddressDelivery,
        getAddressDelivery,

        changePayment,
        setChangePayment,
        getChangePayment,

        getOrderToVerify,
        setOrderToVerify,
        orderToVerify,

        cpfVendor,
        getCpfVendorByLink,
        cpfVendorByLink,

        shouldUpdadeCart,
        getshouldUpdadeCart,
        setShouldUpdadeCustomerCart,
        setGuidCartNew,
        getGuidCartNew,

        setProductsOrder,

        serviceTaxes,
        getServiceTaxes,
        setServiceTaxes,
        setSellerInfoData,
        sellerInfo,
        getSellerInfo,
        catalogSeller,
        setCatalogSellerFunction,
        getCatalogSeller,

        getPaymentDiscount,
        setPaymentDiscountFunction,
        paymentDiscount,
        removePaymentDiscountFunction,
        getInstallment,
        getInstallmentValue,
        originalSellerFreight,
        setOriginalSellerFreight,
        isSellerCart,
        setIsSellerCart,
      }}
    >
      {props.children}
    </OrderContext.Provider>
  );
}
